<template>
    <div></div>
</template>

<script>
  const ROLL_PITCH_CONTROL_MAX_VELOCITY = 15;
  const VERTICAL_CONTROL_MAX_VELOCITY = 4;

  export default {
    name: "Gamepad",
    data: () => ({
      gamepad: null,
      gamepadMovementIntervalId: null,
    }),
    mounted() {
      window.addEventListener("gamepadconnected", (event) => {
        this.$emit("gamepadconnected");
        this.gamepad = event.gamepad;

        let leftJoyStick = {
          radius: 0,
          angle: 0
        }
        let rightJoyStick = {
          radius: 0,
          angle: 0
        }

        this.gamepadMovementIntervalId = setInterval(function() {
          this.gamepad = navigator.getGamepads()[0];
          leftJoyStick.radius = this.computeRadius(this.gamepad.axes[0], this.gamepad.axes[1], VERTICAL_CONTROL_MAX_VELOCITY);
          leftJoyStick.angle = this.computeAngle(this.gamepad.axes[0], this.gamepad.axes[1]);
          rightJoyStick.radius = this.computeRadius(this.gamepad.axes[2], this.gamepad.axes[3], ROLL_PITCH_CONTROL_MAX_VELOCITY);
          rightJoyStick.angle = this.computeAngle(this.gamepad.axes[2], this.gamepad.axes[3]);

          this.$emit("gamepadmovement", leftJoyStick, rightJoyStick);
        }.bind(this), 100);
      });

      window.addEventListener("gamepaddisconnected", () => {
        this.$emit("gamepaddisconnected");

        if (this.gamepadMovementIntervalId != null) {
          clearInterval(this.gamepadMovementIntervalId);
        }
        this.gamepad = null;
      });
    },
    methods: {
      computeRadius(x, y, maxVelocity) {
        return Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2)) * maxVelocity;
      },
      computeAngle(x, y) {
        // gives us back angle in radians
        if (y === 0 || x === 0) {
          return 0;
        }

        // up direction on joystick is negative, therefore invert it
        let angle = Math.atan2(y*-1, x);

        // angle returned is between [-PI, PI], we need [0, 2PI]
        if (angle < 0) {
          angle += 2*Math.PI
        }

        return angle;
      }
    }
  }
</script>

<style scoped>

</style>
